import * as ko from "knockout";
import * as $ from "jquery";
ko.bindingHandlers.baoNumberBox = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        var config = ko.utils.unwrapObservable(valueAccessor());
        var valueBinding = valueAccessor().value;
        var valueString = valueAccessor().valueString;
        var _valueBindingActive = false;
        var setCulture = function (currentValue) {
            _valueBindingActive = true;
            var initValue = currentValue;
            var culture = ko.utils.unwrapObservable(config.culture) || "de-DE";
            var decimals = ko.utils.unwrapObservable(config.decimalDigits);
            if (decimals == null) {
                decimals = 2;
            }
            var useThousandSep = ko.utils.unwrapObservable(config.thousandSeperator);
            if (useThousandSep == null) {
                useThousandSep = true;
            }
            var decSep = ".";
            var thousandSep = ",";
            switch (culture) {
                case "de-DE":
                    decSep = ",";
                    thousandSep = ".";
                    break;
                case "fr-FR":
                    decSep = ",";
                    useThousandSep = false;
                    thousandSep = ".";
                    break;
                default:
                    break;
            }
            if (currentValue !== "") {
                if (typeof currentValue == "number") {
                    currentValue = currentValue.toString().replace(".", decSep);
                }
                var tempValue = currentValue;
                for (var z = 0; z < currentValue.length; z++) {
                    if (currentValue[z] == "0") {
                        tempValue = currentValue.substring(z + 1);
                    }
                    else {
                        break;
                    }
                }
                currentValue = tempValue;
                var prefix = currentValue;
                var sufix = "";
                var i = currentValue.lastIndexOf(decSep);
                if (i > -1) {
                    prefix = currentValue.substring(0, i);
                    sufix = currentValue.substring(i + 1);
                }
                var minusChar = "";
                if (prefix.indexOf("-") == 0) {
                    minusChar = "-";
                    prefix = prefix.replace(/\-/g, "");
                }
                prefix = prefix.replace(/\./g, "").replace(/,/g, "");
                if (prefix == "") {
                    prefix = "0";
                }
                if (prefix.length > 3 && useThousandSep == true) {
                    var tempPrefix = "";
                    for (var x = 0; x < prefix.length; x++) {
                        if (x % 3 == 0 && x != 0) {
                            tempPrefix = thousandSep + tempPrefix;
                        }
                        tempPrefix = prefix[prefix.length - 1 - x] + tempPrefix;
                    }
                    prefix = tempPrefix;
                }
                if (sufix.length >= decimals) {
                    if (decimals > 0) {
                        let decimalValue = (Math.round((parseFloat("." + sufix) + Number.EPSILON) * Math.pow(10, decimals)) / Math.pow(10, decimals)).toString();
                        let decimalIndex = decimalValue.lastIndexOf(".");
                        sufix = decimalValue.substring(decimalIndex + 1);
                    } else {
                        sufix= sufix.substring(0, decimals);
                    }
                }
                else {
                    var tempSufix = "";
                    for (var y = 0; y < decimals; y++) {
                        if (y + 1 <= sufix.length) {
                            tempSufix = tempSufix + sufix[y];
                        }
                        else {
                            tempSufix = tempSufix + "0";
                        }
                    }
                    sufix = tempSufix;
                }
                if (decimals == 0) {
                    decSep = "";
                }
                currentValue = minusChar + prefix + decSep + sufix;
                var replacer = thousandSep;
                var re = new RegExp("\\" + replacer, "g");
                if (decimals == 0) {
                    var intValue = parseInt(minusChar + prefix.replace(re, ""));
                    if (intValue != null) {
                        valueBinding(intValue);
                    }
                }
                else {
                    var floatValue = parseFloat(minusChar + prefix.replace(re, "") + "." + sufix);
                    if (floatValue != null) {
                        valueBinding(floatValue);
                    }
                }
            }
            var leadingZeros = "";
            if (config.allowLeadingZero == true && currentValue != "0") {
                for (var y = 0, len = initValue.length; y < len; y++) {
                    if (initValue[y] == "0") {
                        leadingZeros = leadingZeros + "0";
                    }
                    else {
                        break;
                    }
                }
            }
            $(element).val(leadingZeros + currentValue);
            if (ko.isObservable(valueString)) {
                valueString(leadingZeros + currentValue);
            }
            _valueBindingActive = false;
        };
        var setValue = function (newValue) {
            _valueBindingActive = true;
            if (newValue == null) {
                newValue = "";
            }
            var numericValue = newValue.toString().replace(/,/g, ".").replace(/ /g, "");
            if (numericValue.indexOf(".") > -1) {
                var decimalPlaces = numericValue.substring(numericValue.lastIndexOf("."));
                var preDecimal = numericValue.substring(0, numericValue.lastIndexOf("."));
                preDecimal = preDecimal.replace(/\./g, "");
                numericValue = preDecimal + decimalPlaces;
            }
            if (numericValue != "") {
                if ($.isNumeric(numericValue) == false) {
                    valueBinding(null);
                    $(element).val("");
                    $(element).focus();
                }
                else {
                    setCulture(newValue);
                }
            }
            else {
                valueBinding(null);
                $(element).val("");
                if (ko.isObservable(valueString) && valueBinding != valueString) {
                    valueString("");
                }
            }
            _valueBindingActive = false;
        };
        $(element).change(function () {
            setValue($(element).val());
        });
        valueBinding.subscribe(function (newValue) {
            if (_valueBindingActive == false) {
                setValue(newValue);
            }
        });
        setValue(valueBinding());
    }
};